// extracted by mini-css-extract-plugin
export default {"section2Container":"style_section2Container__oUxdn","dropDown":"style_dropDown__MjQ+0","carScale":"style_carScale__-Daaz","bottomSection":"style_bottomSection__SyzA1"};